var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGatIconAt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5013 21.8C19.4468 21.8 21.8346 19.4122 21.8346 16.4666C21.8346 13.5211 19.4468 11.1333 16.5013 11.1333C13.5558 11.1333 11.168 13.5211 11.168 16.4666C11.168 19.4122 13.5558 21.8 16.5013 21.8Z",
    stroke: "#1E1E20",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8346 11.1334V17.8001C21.8346 18.861 22.2561 19.8784 23.0062 20.6285C23.7564 21.3787 24.7738 21.8001 25.8346 21.8001C26.8955 21.8001 27.9129 21.3787 28.6631 20.6285C29.4132 19.8784 29.8346 18.861 29.8346 17.8001V16.4668C29.8345 13.4575 28.8163 10.5368 26.9457 8.17949C25.0751 5.82223 22.4621 4.16708 19.5315 3.48318C16.601 2.79928 13.5252 3.12684 10.8044 4.41261C8.08366 5.69837 5.87784 7.86672 4.54566 10.5651C3.21347 13.2634 2.83327 16.3331 3.46687 19.2749C4.10047 22.2168 5.71062 24.8578 8.03549 26.7685C10.3604 28.6792 13.2632 29.7472 16.2721 29.799C19.2809 29.8507 22.2188 28.8831 24.608 27.0535",
    stroke: "#1E1E20",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatIconAt);
export default __webpack_public_path__ + "static/media/gat-icon-at.80203d99489812085b50115252ecb4e5.svg";
export { ForwardRef as ReactComponent };